const NextI18Next = require("next-i18next/pages");

const COMMON_NAMESPACES = ['navbar', 'footer', 'common', 'cookie', 'periodic-review', 'economic-activities']

module.exports = { ...NextI18Next, COMMON_NAMESPACES };
